import {Component, OnInit} from '@angular/core';
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {HerosHomeService} from "../../app-mkt/dashboard-mkt/heros-home/services/heros-home.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-hero-section',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgForOf,
    NgIf
  ],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.css'
})
export class HeroSectionComponent implements OnInit{

  allHomeHeros: any[]= [];
  imgUrl = environment.imgUrl;


  constructor(
    private herosHomeService: HerosHomeService,
  ) {
  }

  ngOnInit() {
    this.getAllHomeHeros();

  }

  getAllHomeHeros() {
    this.herosHomeService.getAllHomeheros().subscribe((data) => {
      this.allHomeHeros = data.data.allHomeHeros;
      console.log(this.allHomeHeros);
    });
  }

}
